module.exports = __webpack_public_path__ + "img/google-search-console.aa2d23f6.svg";